<template>
<div>
    <b-table hover ref="billTable" :items="items" :fields="fields" :filter="search"
    @row-selected="$emit('onRowSelected' , $event)" :per-page="search.perPage"
    :current-page="search.page" responsive show-empty selectable>
        <template slot="HEAD_selected">
            <b-form-checkbox v-model="checkSelect" @change="$emit('selectAllRows')" ></b-form-checkbox>
        </template>
        <template slot="selected" slot-scope="{ rowSelected }" :disabled="row.item.status!='transferred'">
            <template v-if="rowSelected">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" checked>
                    <label class="custom-control-label"></label>
                </div>
            </template>
            <template v-else>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" autocomplete="off" class="custom-control-input" value="false">
                    <label class="custom-control-label"></label>
                </div>
            </template>
        </template>
        <template slot="status" slot-scope="row">
            <b-badge :variant="badgeStatus[row.item.status].color" >
                {{badgeStatus[row.item.status].text}}
            </b-badge>
        </template>
    </b-table>
    <div class="mt-3">
        <b-pagination :value="search.page" @input="changePage" :total-rows="totalItems" :current-page="search.page" :per-page="search.perPage" align="right">
        </b-pagination>
    </div>
</div>
</template>

<script>
export default {
    props: {
        items: Array,
        selected: Array,
        fields: Array,
        search: Object,
        totalItems: Number
    },
    data() {
        return {
            userLogin: '',
            checkSelect: false,
            badgeStatus: {
                'wait': {
                    text: 'รอโอน',
                    color: 'warning'
                },
                'transferred': {
                    text: 'โอนเงินเรียบร้อย',
                    color: 'success'
                }
            }
        }
    },
    mounted() {
        this.userLogin = JSON.parse(localStorage.getItem("user"))
    },
    methods: {
        changePage(i) {
            if (this.search.page == i) return;
            this.search.page = i
        },
    },
    computed: {

    }
}
</script>
